(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["westjune-header"]) return;
  try {
    
if (!customElements.get('westjune-navigation')) {
  customElements.define('westjune-navigation', class extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const menus = [...this.querySelectorAll('details')];
      const closeMenus = (restoreFocus = false) => menus.forEach(menu => {
        if (menu.open) {
          menu.open = false;
          if (restoreFocus) menu.querySelector('summary').focus();
        }
      });
      document.addEventListener('click', event => { if (!this.contains(event.target)) closeMenus(); }, options);
      this.addEventListener('keydown', event => { if (event.key === 'Escape') closeMenus(true); }, options);
      this.addEventListener('click', event => { if (event.target.closest('a')) closeMenus(); }, options);
      this.addEventListener('focusout', event => { if (!this.contains(event.relatedTarget)) closeMenus(); }, options);
      matchMedia('(max-width: 989px)').addEventListener('change', () => closeMenus(), options);
    }
    disconnectedCallback() { this.events?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
